import api from '@/api'

export const getters = {
  getSponsorshipsFromUserId: (state) => (userId) =>
    state.sponsorships.filter((s) => s.sponsorId === userId),
}

export const actions = {
  async fetchSponsorships() {
    this.sponsorships = await api.fetchSponsorships()
  },

  async saveNewSponsorship(matchDetails) {
    await api.saveSponsorship(matchDetails)
    await this.fetchSponsorships()
  },

  async updateSponsorship(matchDetails) {
    await api.updateSponsorship(matchDetails)
    await this.fetchSponsorships()
  },

  async deleteSponsorship(matchDetails) {
    await api.deleteSponsorship(matchDetails)
    await this.fetchSponsorships()
  },
}
